import React from 'react';
import {Col, Row} from 'react-bootstrap';
const HeaderLogo = () => 
(
    <Row>
    <Col className="d-none d-sm-block" style={{padding:'40px 0px 75px 35px'}}>
        <img width={154} height={84} alt="thumbnail" src="media/bdonew.png" />          
    </Col>
    <Col className="d-block d-sm-none">
        <img style={{minWidth: '40px', minHeight: '25px'}} height={13} alt="thumbnail" src="media/bdologo.jpg" /> 
    </Col>
    </Row>
);
export default HeaderLogo;